import { DataTestIds } from '@repo/frontend-shared';
import { SDSFlexbox, type SDSFlexboxDirection } from '@repo/sds/SDSFlexbox';

import type { SettingsPanelItemProps } from '../SettingsPanelItem/SettingsPanelItem';
import { SettingsPanelItem } from '../SettingsPanelItem/SettingsPanelItem';

import './SettingsPanel.scss';

interface SettingsPanelProps {
  items: SettingsPanelItemProps[];
  dataTestId?: string;
  direction?: SDSFlexboxDirection;
}

export function SettingsPanel({ dataTestId, items, direction = 'column' }: SettingsPanelProps) {
  return (
    <aside data-testid={dataTestId ?? DataTestIds.COMMON.SETTING_PANEL.PANEL} className="SettingsPanel">
      <SDSFlexbox className="SettingsPanel__content" direction={direction} gap="text-x-large" fullWidth>
        {items.map(item => (
          <SettingsPanelItem testid={item.testid} key={item.title} {...item} />
        ))}
      </SDSFlexbox>
    </aside>
  );
}
